import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=2dd9629e&scoped=true&"
import script from "./TermsPage.vue?vue&type=script&lang=ts&"
export * from "./TermsPage.vue?vue&type=script&lang=ts&"
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=2dd9629e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd9629e",
  null
  
)

export default component.exports